import Modal, { ModalBody, ModalHeader, Sheets } from '@ingka/modal';
import { t } from '@onlinepayments/payments-library';

import ServiceOrderListItem from '../../../../components/OrderItemList/ServiceOrderListItem';
import { LineType } from '../../../../enums/LineType';
import { OrderItem } from '../../../../interfaces/Order';
import { OrderSummaryModalItem } from '../OrderSummaryModalItem';

import './OrderSummaryModal.scss';

type OrderSummaryModalProps = {
  isOpen: boolean;
  onClose: () => void;
  items: OrderItem[];
  currency: string;
};

export const OrderSummaryModal = ({ isOpen, onClose, items, currency }: OrderSummaryModalProps) => {
  const title = `${t('order_info_header')} (${items.length})`;

  return (
    <Modal className="OrderSummaryModal" visible={isOpen} handleCloseBtn={onClose} escapable>
      <Sheets
        alignment="right"
        size="small"
        header={<ModalHeader floating />}
        footer={null}
        aria-label={title}
      >
        <ModalBody>
          <h1 className="OrderSummaryModal__title">{title}</h1>

          <ul className="OrderSummaryModal__list" data-testid="orderSummaryModalList">
            {items.map((item, index) => {
              const { itemNo, lineType } = item.orderLine;

              if (lineType === LineType.Item) {
                return (
                  <OrderSummaryModalItem
                    key={`${itemNo}-${index}`}
                    item={item}
                    currency={currency}
                  />
                );
              }

              if (lineType === LineType.Service) {
                return <ServiceOrderListItem key={`${itemNo}-${index}`} item={item} />;
              }

              return null;
            })}
          </ul>
        </ModalBody>
      </Sheets>
    </Modal>
  );
};
